import Operations from './views/Operations'
import Operation from './views/Operation'

export default {
    routes: [
        {
            path: '/module/finance',
            name: 'Operations',
            component: Operations,
            meta: {toolbars: ['Operations']}
        },
        {
            path: '/module/finance/:operation_id',
            name: 'Operation',
            components: {default: Operations, right: Operation},
            meta: {toolbars: ['Operations']}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/modules/finance/routes.js